<template>
    <b-modal content-class="argus-glass-dialog"
        v-model="show"
        :title="title"
        size="md"
        centered
        scrollable
        hide-footer
        :hide-header-close="loading"
        :no-close-on-backdrop="loading"
        :no-close-on-esc="loading"
    >
        <b-alert :variant="variant" show class="mb-3">
            <i class="fas fa-info-circle mr-2" aria-hidden="true"></i>
            {{ alertText }}
        </b-alert>

        <b-form-checkbox
            v-if="!required"
            v-model="includeComment"
            :disabled="loading"
            @change="onIncludeCommentChange"
        >
            Добавить комментарий
        </b-form-checkbox>

        <b-form-group
            v-if="required || includeComment"
            :label="required ? `${commentLabel} *` : commentLabel"
            label-for="closing-action-comment"
            class="mt-3 mb-0"
            invalid-feedback="Введите комментарий"
            :state="commentState"
        >
            <DiscussionEditor
                id="closing-action-comment"
                ref="commentInput"
                v-model="comment"
                :placeholder="placeholder"
                :disabled="loading"
                :state="commentState"
            />
            <small class="text-muted d-block mt-2">
                Комментарий сохранится в истории заявки.
            </small>
        </b-form-group>

        <div class="closing-action-modal__footer mt-4">
            <b-button variant="outline-secondary" :disabled="loading" @click="close">
                Отмена
            </b-button>
            <b-button :variant="variant" :disabled="!isValid || loading" @click="confirm">
                <b-spinner v-if="loading" small class="mr-1"></b-spinner>
                {{ loading ? loadingText : confirmText }}
            </b-button>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'ClosingActionModal',
    props: {
        value: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
        required: { type: Boolean, default: false },
        title: { type: String, default: 'Закрытие заявки' },
        alertText: { type: String, default: 'Заявка будет переведена в закрывающий статус.' },
        commentLabel: { type: String, default: 'Комментарий' },
        placeholder: { type: String, default: 'Введите комментарий…' },
        confirmText: { type: String, default: 'Подтвердить' },
        loadingText: { type: String, default: 'Сохранение…' },
        variant: { type: String, default: 'success' }
    },
    data() {
        return {
            includeComment: false,
            comment: ''
        };
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                if (!this.loading) this.$emit('input', value);
            }
        },
        trimmedComment() {
            return String(this.comment || '').trim();
        },
        isValid() {
            return this.required
                ? this.trimmedComment.length > 0
                : (!this.includeComment || this.trimmedComment.length > 0);
        },
        commentState() {
            if (!this.required && !this.includeComment) return null;
            return this.trimmedComment.length > 0 ? true : false;
        }
    },
    watch: {
        value(isOpen) {
            if (isOpen && this.required) {
                this.includeComment = true;
                this.focusComment();
            }
        },
        required(value) {
            if (value) this.includeComment = true;
        }
    },
    methods: {
        focusComment() {
            this.$nextTick(() => {
                const input = this.$refs.commentInput;
                if (input && typeof input.focus === 'function') input.focus();
            });
        },
        onIncludeCommentChange(value) {
            if (value) this.focusComment();
        },
        close() {
            if (!this.loading) this.$emit('input', false);
        },
        confirm() {
            if (!this.isValid || this.loading) return;
            const comment = this.required || this.includeComment ? this.trimmedComment : null;
            this.$emit('confirm', comment);
        },
        reset() {
            this.includeComment = this.required;
            this.comment = '';
        }
    }
};
</script>

<style scoped>
.closing-action-modal__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
}
</style>
